/* Navigation Recitem. Aucun changement des scripts du panier et des produits. */
(() => {
  if (!customElements.get('rc-desktop-nav')) {
    class RecitemDesktopNav extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.menus = [...this.querySelectorAll('.rc-nav-dropdown')];
        this.hover = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.menus.forEach(menu => {
          menu.addEventListener('pointerenter', () => {
            if (!this.hover.matches) return;
            clearTimeout(this.closeTimer);
            clearTimeout(this.openTimer);
            this.openTimer = setTimeout(() => {
              this.menus.forEach(other => { other.open = other === menu; });
            }, 80);
          }, options);
          menu.addEventListener('pointerleave', () => {
            if (!this.hover.matches) return;
            clearTimeout(this.openTimer);
            this.closeTimer = setTimeout(() => {
              if (!menu.contains(document.activeElement)) menu.open = false;
            }, 180);
          }, options);
        });
        this.addEventListener('toggle', event => {
          if (event.target.open && this.menus.includes(event.target)) {
            this.menus.forEach(menu => { if (menu !== event.target) menu.open = false; });
          }
        }, { ...options, capture: true });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const menu = event.target.closest('.rc-nav-dropdown[open]');
          if (!menu) return;
          event.preventDefault();
          clearTimeout(this.openTimer);
          clearTimeout(this.closeTimer);
          menu.open = false;
          menu.querySelector('summary').focus();
        }, options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => { if (!this.contains(document.activeElement)) this.closeAll(); });
        }, options);
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.closeAll();
        }, options);
        window.addEventListener('resize', () => this.closeAll(), options);
      }
      closeAll() {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        this.menus.forEach(menu => { menu.open = false; });
      }
      disconnectedCallback() { this.closeAll(); this.controller?.abort(); }
    }
    customElements.define('rc-desktop-nav', RecitemDesktopNav);
  }

  if (!customElements.get('rc-mobile-nav')) {
    class RecitemMobileNav extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const header = [...document.querySelectorAll('[data-section-type="header"]')]
          .find(node => node.dataset.sectionId === this.dataset.headerId);
        this.trigger = header?.querySelector('#mobile-nav');
        if (!this.trigger || !this.dialog) return;
        this.trigger.setAttribute('aria-controls', this.dialog.id);
        this.trigger.setAttribute('aria-expanded', 'false');
        this.trigger.setAttribute('aria-haspopup', 'dialog');
        this.trigger.setAttribute('role', 'button');
        this.trigger.addEventListener('click', event => {
          event.preventDefault();
          this.open();
        }, options);
        this.trigger.addEventListener('keydown', event => {
          if (event.key === ' ') { event.preventDefault(); this.open(); }
        }, options);
        this.querySelector('[data-rc-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => this.release(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index), options);
          tab.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight') target = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') target = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = this.tabs.length - 1;
            if (target === undefined) return;
            event.preventDefault();
            this.selectTab(target);
            this.tabs[target].focus();
          }, options);
        });
        window.addEventListener('resize', () => {
          if (this.dialog.open && !this.trigger.getClientRects().length) this.dialog.close();
        }, options);
        window.addEventListener('pagehide', () => {
          if (this.dialog.open) this.dialog.close();
          this.release(false);
        }, options);
      }
      selectTab(index) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls'))).hidden = !selected;
        });
        const search = this.querySelector('.rc-nav-search');
        if (search) search.hidden = this.tabs[index].getAttribute('aria-controls').endsWith('-brand');
        this.querySelector('.rc-nav-scroll').scrollTop = 0;
      }
      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.selectTab(0);
        this.trigger.setAttribute('aria-expanded', 'true');
        this.scrollY = window.scrollY;
        this.savedBody = {};
        ['position', 'top', 'width', 'overflow'].forEach(name => {
          this.savedBody[name] = [document.body.style.getPropertyValue(name), document.body.style.getPropertyPriority(name)];
        });
        document.body.style.setProperty('position', 'fixed');
        document.body.style.setProperty('top', `-${this.scrollY}px`);
        document.body.style.setProperty('width', '100%');
        document.body.style.setProperty('overflow', 'hidden');
      }
      release(restoreFocus = true) {
        if (this.savedBody) {
          Object.entries(this.savedBody).forEach(([name, [value, priority]]) => {
            if (value) document.body.style.setProperty(name, value, priority);
            else document.body.style.removeProperty(name);
          });
          this.savedBody = null;
          window.scrollTo({ top: this.scrollY, behavior: 'instant' });
        }
        this.trigger?.setAttribute('aria-expanded', 'false');
        if (restoreFocus && this.trigger?.isConnected && this.trigger.getClientRects().length) this.trigger.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.release(false);
      }
    }
    customElements.define('rc-mobile-nav', RecitemMobileNav);
  }
})();
